import classNames from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import { ReactNode, useMemo } from 'react'

import { useWindowDimensions } from '@apps-common/hooks/useWindowDimensions'
import { useMenuStore } from '@apps-common/stores/menuStore'

interface IProps {
  id?: string
  children: ReactNode
  padTop?: boolean
  bgClasses?: string
  overlayClasses?: string
  noSidebar?: boolean
  scrollable?: boolean
  overflowVisible?: boolean
}

export const PageContentContainer: React.FC<IProps> = ({
  id,
  children,
  padTop = false,
  bgClasses,
  overlayClasses,
  noSidebar,
  scrollable = true,
  overflowVisible
}) => {
  const { open, setOpen } = useMenuStore()
  const { width, isMobile, isTablet } = useWindowDimensions()

  const closedWidth = noSidebar || !width || isMobile || isTablet ? '0px' : '80px'

  const mlValue = useMemo(() => (!noSidebar && open ? '230px' : closedWidth), [open, closedWidth])

  if (!width) return null

  return (
    <>
      <AnimatePresence>
        {!noSidebar && open && (
          <motion.div
            id={id}
            initial={false}
            animate={{
              translateX: mlValue,
              opacity: open ? 1 : 0,
              transition: { type: 'tween' }
            }}
            className={classNames(overlayClasses, 'fixed top-0 left-0 bg-bg/5 w-full h-[100dvh] z-[99] ')}
            onClick={() => {
              if (open) {
                setOpen(false)
              }
            }}
          />
        )}
      </AnimatePresence>
      <motion.div
        id={id}
        initial={false}
        animate={{
          left: mlValue,
          opacity: open ? 0.5 : 1,
          transition: { type: 'tween' }
        }}
        className={classNames(
          bgClasses,
          scrollable && 'relative bg-bg text-text overflow-y-auto scrollbar-none',
          !scrollable && !overflowVisible && 'relative bg-bg text-text overflow-hidden',
          !scrollable && overflowVisible && 'relative bg-bg text-text overflow-visible',
          (noSidebar || isMobile || isTablet) && 'w-full',
          !noSidebar && !isMobile && !isTablet && 'w-[calc(100%-100px)]',
          padTop && 'top-padding'
        )}
      >
        {children}
      </motion.div>
    </>
  )
}
